import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  myMaker: [],
  sharedMaker: [],
  myList: null,
  sharedList: null,
  promise: {},
  shareUser: [],
  images: { USER: [] },
  categories: [],
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
